<template>
  <div class="row">
    <div class="col-md-3">
      <div class="form-group">
        <label><strong>ID:</strong></label>
        <p>{{ imovel.id }}</p>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label><strong>Tipo Imóvel:</strong></label>
        <p>{{ imovel.tipo_imovel }}</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label><strong>Descrição:</strong></label>
        <p>{{ imovel.descricao }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>CEP:</strong></label>
        <p>{{ imovel.cep }}</p>
      </div>
    </div>
    <div class="col-md-8">
      <div class="form-group">
        <label><strong>Endereço:</strong></label>
        <p>{{ imovel.endereco }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Número:</strong></label>
        <p>{{ imovel.numero }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Complemento:</strong></label>
        <p>{{ imovel.complemento }}</p>
      </div>
    </div>
    <div class="col-md-7">
      <div class="form-group">
        <label><strong>Bairro:</strong></label>
        <p>{{ imovel.bairro }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Cidade:</strong></label>
        <p>{{ imovel.cidade }}</p>
      </div>
    </div>
    <div class="col-md-1">
      <div class="form-group">
        <label><strong>UF:</strong></label>
        <p>{{ imovel.uf }}</p>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label><strong>Valor:</strong></label>
        <p class="text-center">{{ imovel.valor }}</p>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label><strong>Valor Negociado:</strong></label>
        <p class="text-center">{{ imovel.valor_negociado }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Previsão Entrega:</strong></label>
        <p>{{ imovel.previsao_entrega }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Data Habita-se:</strong></label>
        <p class="text-center">{{ imovel.habita_se }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Data Chaves:</strong></label>
        <p>{{ imovel.entrega_chaves }}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label><strong>Observação:</strong></label>
        <p>{{ imovel.observacao }}</p>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label><strong>Status:</strong></label>
        <p v-html="imovel.status"></p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Nº Quartos: </strong></label>
        <p>{{ imovel.numero_quartos }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Nº Banheiros: </strong></label>
        <p>{{ imovel.numero_banheiros }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong title="Vagas de garagem">Nº Vagas:</strong></label>
        <p>{{ imovel.numero_vagas }}</p>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label><strong>Valor Condomínio:</strong></label>
        <p>{{ imovel.valor_condominio }}</p>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label><strong title="Metros quadrados">M2: </strong></label>
        <p>{{ imovel.m2 }}</p>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <label><strong>Descritivo:</strong></label>
        <p>{{ imovel.descritivo }}</p>
      </div>
    </div>
  </div>
  <div class="ibox-footer">
    <button class="btn btn-success font-bold" @click="$emit('fechar')">
      Fechar
    </button>
  </div>

</template>

<script>
import {apiUrl} from "@/router/apiBackRoutes";

export default {
  nome: 'InformacoesImovel',
  props: {
    imovelId: Number,
    imovelKey: String,
  },
  emits: ['fechar'],
  data() {
    return {
      imovel: 1, // Detalhes do corretor
      erro: null,
    };
  },
  methods: {
    async fetchImovelDetail() {
      try {
        const response = await fetch(`${apiUrl.imoveis.retrieveUpdateDestroy(this.imovelKey)}?modo=info`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: 'include',
        });
        if (!response.ok) {
          this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        }
        const data = await response.json();
        this.imovel = data

      } catch (error) {
        this.erro = error.message;
        console.log(error)
      }
    }
  },
  created() {
    this.fetchImovelDetail();
  },
}
</script>